import React, { Fragment, useEffect, useState } from "react";
import "./Fees.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  DialogTitle,
  DialogActions,
  Input,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  InputAdornment,
  Icon,
} from "@mui/material";

import ListAltIcon from "@mui/icons-material/ListAlt";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { API_URL, backend } from "../../../config";

const Fees = (props) => {
  const { bulkState, data, locked, handleFeesChange } = props;

  const [openFeesDialog, setOpenFeesDialog] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [margins, setMargins] = useState([]);
  const [surcharges, setSurcharges] = useState([]);
  const [order, setOrder] = useState({
    id: "Unknown",
    customer: { username: "Unknown" },
  });
  const [feeInfo, setFeeInfo] = useState({
    fee_type: "",
    type: "",
    amount: "",
    aprice: "",
    oprice: "",
    description: "",
    company_location: null,
    product: null,
    warehouse: "",
    id: null,
    modified: false,
    deleted: false,
    new: true,
  });
  const [feesMethod, setFeesMethod] = useState([]);
  const [feesType, setFeesType] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const handleCloseFeesDialog = () => setOpenFeesDialog(false);

  const handleClickFeesDialog = () => setOpenFeesDialog(true);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const [type, attrName, objIndex] = name.split("-");
    const feeWarehouse = attrName.includes("warehouse")
      ? warehouses.find((item) => item.id === value)
      : null;

    if (type === "margin") {
      setMargins((prevState) => {
        let orderItemFees = prevState.map((fee, index) => {
          if (+objIndex !== index) return fee;
          return {
            ...fee,
            [attrName]: value,
            warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
            modified: true,
          };
        });

        return orderItemFees;
      });
    } else {
      setSurcharges((prevState) => {
        let orderItemFees = prevState.map((fee, index) => {
          if (+objIndex !== index) return fee;
          return {
            ...fee,
            [attrName]: value,
            warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
            modified: true,
          };
        });

        return orderItemFees;
      });
    }
  };

  const handleChangeFee = (e) => {
    const { name, value, checked } = e.target;
    setFeeInfo((prevState) => ({
      ...prevState,
      [name]: name.includes("transparent")
        ? checked
        : name.includes("_date")
        ? value.toISOString()
        : value,
    }));
  };

  const handleClickAddFee = () => {
    const defaultWarehouse = warehouses.filter((item) =>
      item.name.includes("Restaurant Depot")
    );

    if (feeInfo.fee_type === "margin") {
      setMargins((prevState) => {
        delete feeInfo.fee_type;

        const feeInfoObj = {
          ...feeInfo,
          product: data.upc,
          warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse.id,
        };

        return [...prevState, feeInfoObj];
      });
    } else {
      setSurcharges((prevState) => {
        delete feeInfo.fee_type;

        const feeInfoObj = {
          ...feeInfo,
          product: data.upc,
          warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse.id,
        };

        return [...prevState, feeInfoObj];
      });
    }

    setFeeInfo({
      fee_type: "",
      type: "",
      amount: "",
      description: "",
      company_location: null,
      product: data.upc,
      warehouse: defaultWarehouse.length ? defaultWarehouse[0] : "",
      id: null,
      modified: false,
      deleted: false,
      new: true,
    });
  };

  const handleClickDeleteFee = (deletedFee) => {
    const [type, feeIndex] = deletedFee.split("-");

    if (type === "margin") {
      setMargins((prevState) =>
        prevState.map((item) => {
          if (item.id !== +feeIndex) return item;
          return { ...item, deleted: true };
        })
      );
    } else {
      setSurcharges((prevState) =>
        prevState.map((item) => {
          if (item.id !== +feeIndex) return item;
          return { ...item, deleted: true };
        })
      );
    }
  };

  const sendRequest = () => {
    setSavingData(true);

    const marginsMap = margins.map((item) => ({ ...item, feeType: "margin" }));
    const surchargesMap = surcharges.map((item) => ({
      ...item,
      feeType: "surcharge",
    }));

    const feesMap = [...marginsMap, ...surchargesMap];

    Promise.all(
      feesMap.map(async (item) => {
        let payload = { ...item };

        let baseURL =
          item.feeType === "margin"
            ? `${API_URL}margintemplates`
            : `${API_URL}surchargetemplates`;

        if (item.deleted) {
          await backend
            .delete(`${baseURL}/${item.id}`)
            .then(() => {
              return item;
            })
            .catch((error) => {
              console.log(error);
            });

          return payload;
        } else if (item.modified && !item.new) {
          delete payload.deleted;
          delete payload.modified;
          delete payload.new;
          delete payload.feeType;

          const payloadObj = { ...item, warehouse: item.warehouseId };
          delete payloadObj.warehouseId;

          await backend
            .patch(`${baseURL}/${item.id}`, payloadObj)
            .then(({ data }) => {
              payload = { ...item, ...data };
            })
            .catch((error) => {
              console.log(error);
            });

          return payload;
        } else if (item.id === null && item.new) {
          delete payload.deleted;
          delete payload.modified;
          delete payload.new;
          delete payload.feeType;

          const payloadObj = { ...item, warehouse: item.warehouseId };
          delete payloadObj.warehouseId;

          await backend
            .post(`${baseURL}/`, payloadObj)
            .then(({ data }) => {
              payload = { ...item, ...data };
            })
            .catch((error) => {
              console.log(error);
            });

          return payload;
        } else {
          return item;
        }
      })
    )
      .then((result) => {
        const marginsNew = result
          .filter((item) => item.feeType === "margin")
          .map((item) => {
            const marginObj = {
              ...item,
              warehouseId: item.warehouse === null ? "" : item.warehouse.id,
            };

            delete marginObj.feeType;

            return marginObj;
          });

        const surchargesNew = result
          .filter((item) => item.feeType === "surcharge")
          .map((item) => {
            const surchargeObj = {
              ...item,
              warehouseId: item.warehouse === null ? "" : item.warehouse.id,
            };

            delete surchargeObj.feeType;

            return surchargeObj;
          });

        setSavingData(false);
        handleFeesChange(data.upc, marginsNew, surchargesNew);
        handleCloseFeesDialog();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const feesMethodTypeGet = () => {
      setFeesMethod(["f", "%"]);
    };

    const feesTypeGet = () => {
      setFeesType(["margin", "surcharge"]);
    };

    feesMethodTypeGet();
    feesTypeGet();
  }, []);

  useEffect(() => {
    const assignUpdateFees = () => {
      setMargins(data.margins);
      setSurcharges(data.surcharges);
    };

    const getOrder = async () => {
      await backend
        .get(`${API_URL}orders/${data.order}`)
        .then(({ data }) => setOrder(data));
    };

    const warehousesGet = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        const dataMap = data.map((item) => ({ id: item.id, name: item.name }));
        const defaultWarehouse = dataMap.filter((item) =>
          item.name.includes("Restaurant Depot")
        );

        setWarehouses(dataMap);
        setFeeInfo((prevState) => ({
          ...prevState,
          warehouse: defaultWarehouse.length ? defaultWarehouse[0] : null,
        }));
      });
    };

    if (openFeesDialog) {
      warehousesGet();
    }
    if (isNaN(order.id) && openFeesDialog) {
      getOrder();
    }
    if (data || openFeesDialog) {
      assignUpdateFees();
    }
  }, [data, openFeesDialog, order]);

  return (
    <>
      <Dialog onClose={handleCloseFeesDialog} open={openFeesDialog}>
        <DialogTitle>Fees</DialogTitle>
        <DialogContent>
          {savingData ? (
            <Grid container spacing={1} textAlign="center">
              <Grid item xs={12}>
                <CircularProgress />
              </Grid>
              <Grid item xs={12}>
                Saving fees information
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  <strong>{`Order #${order.id}`}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  <strong>Customer: </strong>
                  {order.customer ? order.customer.username : "Anonymous"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  <strong>Placed: </strong>
                  {order.hasOwnProperty("created_date")
                    ? new Date(order.created_date).toISOString().split("T")[0]
                    : "Unknown"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12}></Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">
                      <strong>{`${data.name} Margins`}</strong>
                    </Typography>
                  </Grid>
                  {!margins.length || margins.every((item) => item.deleted) ? (
                    <>
                      <Grid item xs={12}>
                        <Typography
                          color="primary"
                          component="h4"
                          style={{ textAlign: "center" }}
                        >
                          There are no margins added
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                  {margins.map((item, index) => (
                    <Fragment key={index}>
                      {index > 0 || margins.every((item) => item.deleted) ? (
                        <></>
                      ) : (
                        <>
                          <Grid item xs={2}>
                            Type
                          </Grid>
                          <Grid item xs={2}>
                            Amount
                          </Grid>
                          <Grid item xs={3}>
                            Warehouse
                          </Grid>
                          <Grid item xs={5}>
                            Description
                          </Grid>
                        </>
                      )}
                      {!item.deleted ? (
                        <>
                          <Grid item xs={2}>
                            <Input
                              name={`margin-type-${index}`}
                              value={item.type}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Input
                              name={`margin-amount-${index}`}
                              value={item.amount}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Input
                              name={`margin-warehouse-${index}`}
                              value={item.warehouse ? item.warehouse.name : ""}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Input
                              fullWidth
                              name={`margin-description-${index}`}
                              value={item.description}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <Tooltip title="Delete">
                              <IconButton
                                aria-label="delete"
                                onClick={() =>
                                  handleClickDeleteFee(`margin-${index}`)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </>
                      ) : (
                        <></>
                      )}
                    </Fragment>
                  ))}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">
                      <strong>{`${data.name} Surcharges`}</strong>
                    </Typography>
                  </Grid>
                  {!surcharges.length ||
                  surcharges.every((item) => item.deleted) ? (
                    <>
                      <Grid item xs={12}>
                        <Typography
                          color="primary"
                          component="h4"
                          style={{ textAlign: "center" }}
                        >
                          There are no surcharges added
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                  {surcharges.map((item, index) => (
                    <Fragment key={index}>
                      {index > 0 || surcharges.every((item) => item.deleted) ? (
                        <></>
                      ) : (
                        <>
                          <Grid item xs={2}>
                            Type
                          </Grid>
                          <Grid item xs={2}>
                            Amount
                          </Grid>
                          <Grid item xs={3}>
                            Warehouse
                          </Grid>
                          <Grid item xs={5}>
                            Description
                          </Grid>
                        </>
                      )}
                      {!item.deleted ? (
                        <>
                          <Grid item xs={2}>
                            <Input
                              name={`surcharge-type-${index}`}
                              value={item.type}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Input
                              name={`surcharge-amount-${index}`}
                              value={item.amount}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Input
                              name={`surcharge-warehouse-${index}`}
                              value={item.warehouse.name}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Input
                              fullWidth
                              name={`surcharge-description-${index}`}
                              value={item.description}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <Tooltip title="Delete">
                              <IconButton
                                aria-label="delete"
                                onClick={() =>
                                  handleClickDeleteFee(`surcharge-${index}`)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </>
                      ) : (
                        <></>
                      )}
                    </Fragment>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            spacing={2}
            style={{ alignItems: "center", marginTop: 24 }}
          >
            <Grid
              container
              alignItems={"center"}
              style={{ justifyContent: "center" }}
            >
              <Typography color="primary" component="h4">
                Add a fee with the following information
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel shrink id="feeTypeLabel">
                Fee Type
              </InputLabel>
              <Select
                fullWidth
                key="fee_type"
                name="fee_type"
                input={<Input />}
                value={feeInfo && feeInfo.fee_type}
                onChange={handleChangeFee}
              >
                {feesType.map((item) => (
                  <MenuItem key={"fee_type_" + item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel shrink id="calculationMethodLabel">
                Calculation Method
              </InputLabel>
              <Select
                fullWidth
                key="type"
                name="type"
                input={<Input />}
                value={feeInfo && feeInfo.type}
                onChange={handleChangeFee}
              >
                {feesMethod.map((item) => (
                  <MenuItem key={"fee_method_" + item} value={item}>
                    {item === "f" ? "Flat" : "Percentage"}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                size="small"
                id="outlined-basic"
                variant="outlined"
                label={`${
                  ["", "f"].includes(feeInfo.type) ? "Flat" : "Percentage"
                }`}
                name="amount"
                InputProps={{
                  startAdornment: ["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">$</InputAdornment>
                  ) : (
                    <></>
                  ),
                  endAdornment: !["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">%</InputAdornment>
                  ) : (
                    <></>
                  ),
                }}
                value={feeInfo && feeInfo.amount}
                onChange={handleChangeFee}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel shrink id="warehouseLabel">
                Warehouse
              </InputLabel>
              <Select
                fullWidth
                key="warehouse"
                name="warehouse"
                input={<Input />}
                value={feeInfo && feeInfo.warehouse}
                onChange={handleChangeFee}
              >
                {warehouses.map((warehouse) => (
                  <MenuItem
                    key={"fee_warehouse_" + warehouse.id}
                    value={warehouse}
                  >
                    {warehouse.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Description"
                name="description"
                value={feeInfo && feeInfo.description}
                onChange={handleChangeFee}
              />
            </Grid>
            <Grid container style={{ justifyContent: "flex-end" }}>
              <Button
                style={{
                  minWidth: "auto",
                  marginTop: 10,
                  padding: "6px 10px",
                }}
                variant="contained"
                color="primary"
                onClick={handleClickAddFee}
                disabled={feeInfo.type === ""}
              >
                Add
                {`${
                  ["", "margin"].includes(feeInfo.fee_type)
                    ? " Margin"
                    : " Surcharge"
                }`}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            onClick={handleCloseFeesDialog}
          >
            Cancel
          </Button>
          <Button color="success" variant="contained" onClick={sendRequest}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {bulkState || locked ? (
        <></>
      ) : margins.length || surcharges.length ? (
        <>
          <Tooltip title="Fees Information">
            {data.out_of_stock ? (
              <Icon style={{ marginLeft: 8, color: "#bbb" }}>
                <ListAltIcon />
              </Icon>
            ) : (
              <IconButton
                aria-label="fees_information"
                onClick={handleClickFeesDialog}
              >
                <ListAltIcon />
              </IconButton>
            )}
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip title="Add Fee Information">
            {data.out_of_stock ? (
              <Icon style={{ marginLeft: 8, color: "#bbb" }}>
                <AddIcon />
              </Icon>
            ) : (
              <IconButton
                aria-label="fees_information"
                onClick={handleClickFeesDialog}
              >
                <AddIcon />
              </IconButton>
            )}
          </Tooltip>
        </>
      )}
    </>
  );
};

export default Fees;
